Namespace 'Customer.Views.Insights'

class Customer.Views.Insights.ActivityMetricGroupSelectorView extends Backbone.View
  template: JST['backbone/templates/customer/insights/activity_columns_group_selector']
  className: 'column-group-selector'

  events:
    'click .select-all': '_selectAllColumns'
    'click .clear-all': '_clearAllColumns'

  initialize: ({@title, @columns, @defaultSelectedColumns, @extraClassName}) ->

  render: ->
    @$el.html @template
      title: @title
      columns: @columns
      defaultSelectedColumns: @defaultSelectedColumns
    @$el.addClass(@extraClassName)

  _selectAllColumns: ->
    @_toggleAllColumns true

  _clearAllColumns: ->
    @_toggleAllColumns false

  _toggleAllColumns: (state) ->
    @$('.available-column').find('input').prop('checked', state)

